import React, { useState } from 'react';
import Dialog from './Dialog';
import useDialogMutation from '../hooks/useDialogMutation';
import { normalizeWebsiteUrl, validateUrl } from './AppDialog';

function VaultToolDialog({ title, submitLabel, app, onSubmit, onClose }) {
  const [name, setName] = useState(app?.name || '');
  const [url, setUrl] = useState(app?.url || '');
  const [note, setNote] = useState(app?.note || '');
  const [errors, setErrors] = useState({});
  const { run, saving, error: saveError } = useDialogMutation();

  const submit = async (event) => {
    event.preventDefault();
    if (saving) return;
    const next = {};
    if (!name.trim()) next.name = 'Tool name is required.';
    const normalizedUrl = normalizeWebsiteUrl(url);
    const urlError = validateUrl(normalizedUrl);
    if (urlError) next.url = urlError;
    setErrors(next);
    if (Object.keys(next).length) return;
    await run(() => onSubmit({
      name: name.trim(),
      url: normalizedUrl,
      note: note.trim()
    }), onClose);
  };

  return (
    <Dialog title={title} onClose={onClose} locked={saving}>
      <form onSubmit={submit} noValidate>
        <label className="dialog-label" htmlFor="vault-tool-name">Name</label>
        <input
          id="vault-tool-name"
          className="dialog-input"
          value={name}
          maxLength={40}
          autoFocus
          disabled={saving}
          aria-invalid={Boolean(errors.name)}
          onChange={(event) => setName(event.target.value)}
        />
        {errors.name && <p className="dialog-error">{errors.name}</p>}
        <label className="dialog-label field-gap" htmlFor="vault-tool-url">Website URL</label>
        <input
          id="vault-tool-url"
          className="dialog-input"
          type="url"
          value={url}
          placeholder="https://example.com/page"
          disabled={saving}
          aria-invalid={Boolean(errors.url)}
          onChange={(event) => setUrl(event.target.value)}
        />
        {errors.url && <p className="dialog-error">{errors.url}</p>}
        <label className="dialog-label field-gap" htmlFor="vault-tool-note">Note (optional)</label>
        <textarea
          id="vault-tool-note"
          className="dialog-input vault-note-input"
          value={note}
          maxLength={240}
          rows={3}
          disabled={saving}
          onChange={(event) => setNote(event.target.value)}
        />
        {saveError && <p className="dialog-error" role="alert">{saveError}</p>}
        <div className="dialog-actions">
          <button type="button" className="btn" onClick={onClose} disabled={saving}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? 'Saving…' : submitLabel}
          </button>
        </div>
      </form>
    </Dialog>
  );
}

export default VaultToolDialog;